import React from 'react';
import { connect } from 'react-redux';
import { MqttConsumer } from 'helpers/mqtt/MqttProvider';

import {
  chatFeedActions,
  chatFeedOperations,
  chatFeedSelectors,
} from '../../duck';

import ChatMessagesComponent from './ChatMessagesComponent';
import { appActions } from 'App/duck';

const mapStateToProps = (state) => {
  const {
    appReducer: {
      location: {
        settings: { cfg__group_chat__comments },
        settings: { cfg__group_chat__likes },
        settings: { cfg__group_chat__post__create },
      },
    },
    chatFeedReducer,
    chatFeedReducer: { active },
    setupReducer,
    appReducer,
    locationReducer,
  } = state;

  return {
    chatMessages: active.chatSession ? chatFeedSelectors.getOrderedChatSessionMessages(active.chatSession)(state) : [],
    active,
    activeChat: chatFeedSelectors.getActiveChatSession(state),
    allowComments: cfg__group_chat__comments,
    allowLikes: cfg__group_chat__likes,
    allowCreatePost: cfg__group_chat__post__create,
    userIsAdmin: setupReducer.setup_actions.meta.current_user.current_is_admin,
    userId: setupReducer.setup_actions.meta.current_user.id,
    locationId: locationReducer.location_code,
    allUsers: appReducer.allUsers.users,
    onlineUsers: appReducer.onlineUsers.users,
    managers: appReducer.managers.users,
    associates: appReducer.associates.users,
  };
};

const mapDispatchToProps = (dispatch) => {

  const fetchChatMessages = (chat_session_id) => {
    dispatch(chatFeedOperations.fetchChatMessages(chat_session_id));
  };

  const fetchMoreChatMessages = (chat_session_id, page) => {
    dispatch(chatFeedOperations.fetchMoreChatMessages(chat_session_id, page));
  };

  const setActivePost = (id, channel_name) => {
    dispatch(chatFeedActions.updateActivePost({ id, channel_name }));
    // dispatch(chatFeedActions.clearReadReceipts());
  };

  const setActiveDelete = ({ id, type }) => {
    dispatch(chatFeedActions.updateActiveDelete({ id, type }));
  };

  const setActiveSidePane = (pane) => {
    dispatch(chatFeedActions.updateActiveSidePane(pane));
  };

  const createPost = (post) => {
    dispatch(chatFeedOperations.createPost(post));
  };

  const createChatMessage = (chat_session_id, chatMessage) => {
    dispatch(chatFeedOperations.createChatMessage(chat_session_id, chatMessage));
  };

  const handleUpdateDeletePost = (post_id) => {
    dispatch(chatFeedOperations.updateDeletePost(post_id));
  };
  const handleUpdateDeleteActivePost = (post_id) => {
    dispatch(chatFeedOperations.updateDeleteActivePost(post_id));
  };
  const handleDeleteChannel = (channel_id) => {
    dispatch(appActions.removeChannel({ id: channel_id }));
  };

  const getLocationOnlineUsers = (users) => {
    dispatch(appActions.receiveOnlineUsers(users));
  };
  const handleAddUserToOnlineList = (user) => {
    dispatch(appActions.appendOnlineUser(user));
  };
  const handleRemoveUserFromOnlineList = (user) => {
    dispatch(appActions.removeOnlineUser(user));
  };

  const setLastPost = (lastPost) => {
    dispatch(chatFeedActions.receiveLastPost(lastPost));
  };

  const updateChannelLastContent = (payload) => {
    dispatch(appActions.updateChannelLastContent(payload));
  };

  const NotifyNewChatMessage = (channelId) => {
    dispatch(chatFeedActions.NotifyNewChatMessage(channelId));
  };

  const deletePost = (postId, lastPost) => {
    dispatch(chatFeedOperations.deletePost(postId, lastPost));
  };

  const handleRemoveUserFromGroup = (channelId, users) => {
    dispatch(chatFeedOperations.leaveGroup(channelId, users));
  };

  const setActiveChatSession = (id) => {
    dispatch(chatFeedActions.updateActiveChatSession(id));
    dispatch(chatFeedActions.updateActivePost({ id: 0, channel_name: '' }));
    dispatch(chatFeedActions.updateActiveDelete({ type: '', id: 0 }));
    dispatch(chatFeedActions.updateActiveSidePane(''));
  };

  const fetchOnePost = (post_id) => {
    dispatch(chatFeedOperations.fetchOnePost(post_id));
  };

  const fetchOneChatMessage = (chatSessionId, chatMessageId) => {
    dispatch(chatFeedOperations.fetchOneChatMessage(chatSessionId, chatMessageId));
  }

  return {
    fetchChatMessages,
    fetchMoreChatMessages,
    setActivePost,
    setActiveDelete,
    setActiveSidePane,
    createPost,
    createChatMessage,
    handleUpdateDeletePost,
    handleUpdateDeleteActivePost,
    handleDeleteChannel,
    getLocationOnlineUsers,
    handleAddUserToOnlineList,
    handleRemoveUserFromOnlineList,
    setLastPost,
    updateChannelLastContent,
    NotifyNewChatMessage,
    deletePost,
    handleRemoveUserFromGroup,
    setActiveChatSession,
    fetchOnePost,
    fetchOneChatMessage,
  };
};

const ChatMessagesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  return (
    <MqttConsumer>
      {(client) => {
        const {
          fetchChatMessages,
          fetchMoreChatMessages,
          setActivePost,
          setActiveDelete,
          setActiveSidePane,
          active,
          posts,
          chatMessages,
          activeChat,
          allowLikes,
          allowComments,
          allowCreatePost,
          createPost,
          createChatMessage,
          handleUpdateDeletePost,
          handleUpdateDeleteActivePost,
          handleDeleteChannel,
          locationId,
          allUsers,
          onlineUsers,
          getLocationOnlineUsers,
          handleAddUserToOnlineList,
          handleRemoveUserFromOnlineList,
          setLastPost,
          updateChannelLastContent,
          NotifyNewChatMessage,
          deletePost,
          handleRemoveUserFromGroup,
          setActiveChatSession,
          managers,
          associates,
          fetchOnePost,
          fetchOneChatMessage,
        } = props;

        return (
          <ChatMessagesComponent
            mqttClient={client}
            fetchChatMessages={fetchChatMessages}
            fetchMoreChatMessages={fetchMoreChatMessages}
            setActivePost={setActivePost}
            setActiveDelete={setActiveDelete}
            setActiveSidePane={setActiveSidePane}
            active={active}
            posts={posts}
            chatMessages={chatMessages}
            activeChat={activeChat}
            allowLikes={allowLikes}
            allowComments={allowComments}
            allowCreatePost={allowCreatePost}
            createPost={createPost}
            createChatMessage={createChatMessage}
            handleUpdateDeletePost={handleUpdateDeletePost}
            handleUpdateDeleteActivePost={handleUpdateDeleteActivePost}
            handleDeleteChannel={handleDeleteChannel}
            locationId={locationId}
            allUsers={allUsers}
            onlineUsers={onlineUsers}
            getLocationOnlineUsers={getLocationOnlineUsers}
            handleAddUserToOnlineList={handleAddUserToOnlineList}
            handleRemoveUserFromOnlineList={handleRemoveUserFromOnlineList}
            setLastPost={setLastPost}
            updateChannelLastContent={updateChannelLastContent}
            NotifyNewChatMessage={NotifyNewChatMessage}
            deletePost={deletePost}
            handleRemoveUserFromGroup={handleRemoveUserFromGroup}
            setActiveChatSession={setActiveChatSession}
            managers={managers}
            associates={associates}
            fetchOnePost={fetchOnePost}
            fetchOneChatMessage={fetchOneChatMessage}
          />
        );
      }}
    </MqttConsumer>
  );
});

export default ChatMessagesContainer;
